import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  noUser: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  avatar: {
    width: 24,
    height: 24,
    marginRight: '0.2rem',
    fontSize: theme.size.sm,
    backgroundColor: ({ noUser }) => noUser && 'lightgray'
  },

  label: {
    marginLeft: 5,
    fontSize: theme.size.sm,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: ({ noUser }) => noUser && 'lightgray'
  }
}))

export default useStyles
